import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.5 21.002v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v7.5m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.352m-16.5 11.65V9.352m0 0a3 3 0 0 0 3.75-.615 3 3 0 0 0 2.25 1.015c.896 0 1.7-.392 2.25-1.015a3 3 0 0 0 2.25 1.015c.896 0 1.7-.392 2.25-1.015q.062.07.128.137a3 3 0 0 0 3.622.477m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19a1.5 1.5 0 0 1 1.06-.439h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72m-13.5 8.651h3.75a.75.75 0 0 0 .75-.75v-3.75a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .415.336.75.75.75"
    }, null, -1)
  ])))
}
export default { render: render }